var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full min-h-full flex-row items-center"},[_c('FormBuilder',{attrs:{"isDefault":true,"editMode":true,"_id":_vm.formId,"pulledFormData":_vm.pulledFormData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }